import { useRouter } from 'vue-router';
import { http } from '@/services/http.service';
import AuthService from '@/services/auth.service';

class UserAPI {
  async fetchUsers(page = 1, search = '') {
    try {
      const res = await http.get(`/api/v1/users?page=${page}&search=${search}`);
      return res.data;
    } catch (error) {
      return error;
    }
  }
  async fetchOnlyActiveUsers(page = 1, search = '') {
    try {
      const res = await http.get(`/api/v1/users/activated_users?page=${page}&search=${search}`);
      return res.data;
    } catch (error) {
      return error;
    }
  }
  async fetchUser(id: number, search = '') {
    if (!search) search = '';

    try {
      const res = await http.get(`/api/v1/users/${id}?search=${search}`);
      return res.data;
    } catch (error) {
      if (error?.error === 'Signature has expired') {
        const router = useRouter();
        AuthService.logout().then(() => {
          router.push({ name: 'sign_in' });
        });
      }
    }
  }
  async updateUser(id: number, data: {}) {
    try {
      const headers = { 'Content-Type': 'multipart/form-data' };
      const res = await http.put(`/api/v1/users/${id}`, data, { headers });
      return res.data;
    } catch (error) {
      return error;
    }
  }
  async impersonateUser(id: number) {
    try {
      const res = await http.post(`/api/v1/impersonate/start_impersonating`, {
        id: id,
      });
      if (res?.data?.user) {
        localStorage.setItem('user', JSON.stringify(res?.data?.user));
        localStorage.setItem('isImpersonating', 'true');
      }
      return res?.data;
    } catch (error) {
      return error;
    }
  }
  async stopImpersonating() {
    try {
      const res = await http.post(`/api/v1/impersonate/stop_impersonating`);
      if (res?.data?.user) {
        localStorage.setItem('user', JSON.stringify(res?.data?.user));
        localStorage.removeItem('isImpersonating');
      }
      return res?.data;
    } catch (error) {
      return error;
    }
  }
  async isImpersonating() {
    try {      
      const res = await http.get(`/api/v1/impersonate/is_impersonating`)
      return res?.data?.isImpersonating;
    } catch (error) {
      console.log(error);
    }
  }
}

const instance = new UserAPI();

export default instance;
